'use client';

import { useEffect, useState } from 'react';
import { CustomerServiceBoxImpl } from './impl';
import { useDynamicYieldReady } from './useDynamicYieldReady';

export const CustomerServiceBox = () => {
  const { dyIsReady, isFallback } = useDynamicYieldReady();
  const [showCustomerServiceBox, setShowCustomerServiceBox] = useState(false);

  useEffect(() => {
    if (dyIsReady || isFallback) {
      setShowCustomerServiceBox(true);
    }
  }, [dyIsReady, isFallback]);

  return showCustomerServiceBox ? <CustomerServiceBoxImpl /> : null;
};
